var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.56689 3.8667C3.56689 3.00951 4.2097 2.3667 5.06689 2.3667H9.26691C10.1133 2.3667 10.7669 3.06527 10.7669 3.8667V9.46671C10.7669 10.3239 10.1241 10.9667 9.26691 10.9667H5.06689C4.2097 10.9667 3.56689 10.3239 3.56689 9.46671V3.8667ZM5.06689 1.3667C3.65741 1.3667 2.56689 2.45722 2.56689 3.8667V9.46671C2.56689 10.8762 3.65741 11.9667 5.06689 11.9667H9.26691C10.6764 11.9667 11.7669 10.8762 11.7669 9.46671V3.8667C11.7669 2.53479 10.6872 1.3667 9.26691 1.3667H5.06689ZM14.4336 6.53337C14.4336 6.25722 14.2097 6.03337 13.9336 6.03337C13.6574 6.03337 13.4336 6.25722 13.4336 6.53337V12.1334C13.4336 12.9906 12.7908 13.6334 11.9336 13.6334H7.73357C7.45744 13.6334 7.23357 13.8572 7.23357 14.1334C7.23357 14.4095 7.45744 14.6334 7.73357 14.6334H11.9336C13.343 14.6334 14.4336 13.5428 14.4336 12.1334V6.53337Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.5e4d09a94aee56fb782cf96835b9541d.svg";
export { ForwardRef as ReactComponent };